import {
	ClientPortfolioInvestmentFrequencyEnum,
	ClientPortfolioInvestmentTypeEnum,
	CurrencyEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const EXCLUDED_INSTRUCTION_TYPES = [
	ClientPortfolioInvestmentTypeEnum.Empty,
] as const;

export const EXCLUDED_INSTRUCTION_FREQUENCIES = [
	ClientPortfolioInvestmentFrequencyEnum.None,
] as const;

export const INSTRUCTION_CURRENCIES = [
	CurrencyEnum.CZK,
	CurrencyEnum.EUR,
	CurrencyEnum.USD,
] as const;

export const DEFAULT_INSTRUCTION_CURRENCY = CurrencyEnum.CZK;

export const DEFAULT_INSTRUCTION_FREQUENCY =
	ClientPortfolioInvestmentFrequencyEnum.Monthly;

// TODO(DEV-3935): Replace with the commodity enum from the API once BE returns it
export const COMMODITY_CODES = [
	"zlato",
	"stribro",
	"platina",
	"palladium",
] as const;

export type CommodityCode = (typeof COMMODITY_CODES)[number];

export const isCommodityCode = (value: string): value is CommodityCode =>
	COMMODITY_CODES.includes(value as CommodityCode);
